// extracted by mini-css-extract-plugin
module.exports = {"grid":"FoodsSectionList_grid__f4myH","title":"FoodsSectionList_title__2CQ5U","title-ltr":"FoodsSectionList_title-ltr__36Kjd"};